export default __webpack_public_path__ + "static/media/edit.dbe6ea35.svg";